import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiServiceService } from '../../services/api-service.service';

@Component({
  selector: 'app-return-refund-model',
  templateUrl: './return-refund-model.component.html',
  styleUrls: ['./return-refund-model.component.scss']
})
export class ReturnRefundModelComponent implements OnInit {
  bankForm: FormGroup;
  userId: string = '';

  constructor(
    private dialogRef: MatDialogRef<ReturnRefundModelComponent>,
    private api: ApiServiceService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {
    this.bankForm = this.fb.group({
      holder_name: ['', Validators.required],
      bank_name: ['', Validators.required],
      account_number: [
        null,
        [Validators.required, Validators.pattern(/^\d{10,15}$/)]
      ],
      ifsc_code: [
        '',
        [Validators.required, Validators.pattern(/^[A-Za-z]{4}\d{7}$/)]
      ],
    });
  }

  ngOnInit(): void {
    // ✅ Get userId from localStorage (based on how your app stores it)
    const storedId = localStorage.getItem('userId') || localStorage.getItem('sellerId');
    if (storedId) {
      this.userId = storedId.replace(/"/g, '');
      this.getBankInfo();
    } else {
      this.toastr.error('User ID not found. Please log in again.');
    }
  }

  // ✅ Fetch existing bank info (if any)
  getBankInfo(): void {
    this.api.getBankInfo(this.userId).subscribe({
      next: (res: any) => {
        if (res?.data) {
          this.bankForm.patchValue(res.data);
        }
      },
      error: (err) => {
        console.error('Error loading bank info:', err);
      }
    });
  }

  // ✅ Submit form (Add or Update)
onSubmit() {
  if (this.bankForm.invalid) {
    this.validateAllFormFields(this.bankForm);
    return;
  }

  const storedId = localStorage.getItem('userId') || localStorage.getItem('sellerId');
  if (!storedId) {
    this.toastr.error('User ID not found. Please log in again.');
    return;
  }

  const payload = {
    ...this.bankForm.value,
    userId: storedId.replace(/"/g, '')
  };

  console.log('Submitting payload:', payload); // 👀 debug log

  this.api.addBankInfo(payload).subscribe({
    next: (response: any) => {
      console.log('Response from API:', response); // 👀 debug log
      this.toastr.success(response.message || 'Bank added successfully!');
      this.closeDialog();
    },
    error: (err) => {
      console.error('Error adding bank:', err);
      this.toastr.error(err.error?.message || 'Failed to add bank.');
    }
  });
}

  // ✅ Mark all fields as touched (for validation)
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control) {
        control.markAsTouched({ onlySelf: true });
      }
    });
  }

  // ✅ Close modal
  closeDialog() {
    this.dialogRef.close();
  }
}
